import { Circle, Style, Fill, Stroke } from 'ol/style';
import type { StyleFunction } from 'ol/style/Style';

const UNSELECTED_COLOR = '#5B7FA5';
const SELECTED_COLOR = '#FF6B00';

const unselectedStyle = new Style({
  image: new Circle({
    radius: 4,
    fill: new Fill({ color: UNSELECTED_COLOR }),
    stroke: new Stroke({ color: '#fff', width: 1.5 }),
  }),
});

const selectedStyle = new Style({
  image: new Circle({
    radius: 5,
    fill: new Fill({ color: SELECTED_COLOR }),
    stroke: new Stroke({ color: '#fff', width: 2 }),
  }),
});

export const createRadarStyleFunction = (
  selectedIds: Set<string>,
): StyleFunction => {
  return (feature) => {
    const id = feature.getId();
    const isSelected = typeof id === 'string' && selectedIds.has(id);
    return isSelected ? selectedStyle : unselectedStyle;
  };
};
